import React from 'react';

const metrics = [
  { id: 1, label: '👥 Profile Views', value: 126 },
  { id: 2, label: '📈 Signal Followers', value: 42 },
  { id: 3, label: '💬 Messages This Week', value: 18 },
  { id: 4, label: '🌐 Portfolio Clicks', value: 75 },
];

export default function MyAnalyticsBox() {
  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold mb-3 text-gray-800">📊 My Analytics</h3>
      <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
        {metrics.map((item) => (
          <div
            key={item.id}
            className="flex flex-col items-center justify-center bg-gray-50 p-3 rounded shadow-sm hover:shadow transition"
          >
            <span className="text-lg font-bold text-blue-600">{item.value}</span>
            <span className="text-xs text-gray-500 text-center mt-1">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
